import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@nexelem/components';
import { toggleProductionPlanSearchDrawer } from './ProductionPlanSearchDrawer';

export const SearchButton = () => (
  <IconButton Icon={<FontAwesomeIcon icon={faSearch} />} onClick={toggleProductionPlanSearchDrawer} />
);
